import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    width: '100%'
  },
  content: {
    marginTop: 32,
    '& .MuiGrid-item': {
      [theme.breakpoints.up('sm')]: {
        flexBasis: '50%',
        maxWidth: '50%'
      }
    }
  },
  title: {
    marginBottom: 24,
    marginTop: 15,
    fontSize: '18px',
    lineHeight: 1.5,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 18,
      fontSize: '16px'
    }
  }
}))
